import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'x-api-key': 'K8wNqnaJvG1SvMRmQcBeA9PM9FQ23AHt4r8zbxZh'
  })
};


@Injectable({
  providedIn: 'root'
})
export class RegisterkadeckdesktopService {



  constructor(private http: HttpClient) { }

  // K8wNqnaJvG1SvMRmQcBeA9PM9FQ23AHt4r8zbxZh
  register(name: string, company: string, phone: string, email: string, newsletter: boolean){
    let request = {
      "mail": email,
      "phone": phone,
      "company": company,
      "name": name,
      "newsletter": newsletter
    }
    console.log("Registration",request);
    return this.http.post("https://connect.xeotek.link/desktoprequest",request, httpOptions);
  }
}
